import { useState } from "react";
import * as queryString from 'query-string'
import { RESULTS_PAGE_URL } from "../constants.js";

const FindAnAceProNamedSearch = (props) => {
    const queryStringParameters = queryString.parse(location.search)
    const [firstName, setFirstName] = useState(queryStringParameters.fname || "")
    const [lastName, setLastName] = useState(queryStringParameters.lname || "")

    const handleSearchClick = (event) => {
        event.preventDefault();
        searchByName();
    }

    const searchByName = () => {
        window.location.replace(RESULTS_PAGE_URL + "?fname=" + firstName + "&lname=" + lastName);
    }

    const handleEnterPressedForSearch = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            searchByName();
        }
    }

    const btnIcon = 'Verify ACE Credential<span class="icon-wrap"><svg aria-hidden="true" class="icon icon--angle-right-bold icon--white"><use xlink:href="#icon-angle-right-bold"></use></svg>';

    return (
        <div>
            <div className="fap-search__input-wrap">
                <input type="text" className="fap-search__input" onChange={(e) => setFirstName(e.target.value)} onKeyPress={handleEnterPressedForSearch} name="firstName" value={firstName} placeholder="First name of professional" />
                <input type="text" className="fap-search__input" onChange={(e) => setLastName(e.target.value)} onKeyPress={handleEnterPressedForSearch} name="lastName" value={lastName} placeholder="Last name of professional" />
            </div>
            <button className="ace-btn-primary fap-search__submit" onClick={handleSearchClick} onKeyPress={handleEnterPressedForSearch} dangerouslySetInnerHTML={{ __html: btnIcon }} />
            <span className="fap-search__indicator-text">*All fields required</span>
        </div>
    )
}

export default FindAnAceProNamedSearch